import { jsx as _jsx } from "react/jsx-runtime";
import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './context/AuthContext';
import { ToastProvider } from './components/Toast';
import Layout from './components/layout/Layout';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ClientesPage from './pages/ClientesPage';
import EquipamentosPage from './pages/EquipamentosPage';
import OrdensServicoPage from './pages/OrdensServicoPage';
import OrdemServicoSuccessPage from './pages/OrdemServicoSuccessPage';
import OrdemServicoFechamentoSuccessPage from './pages/OrdemServicoFechamentoSuccessPage';
import OrdensServicoArquivoPage from './pages/OrdensServicoArquivoPage';
import OrcamentosPage from './pages/OrcamentosPage';
import OrcamentoDetailsPage from './pages/OrcamentoDetailsPage';
import OrcamentoFormPage from './pages/OrcamentoFormPage';
import FecharOSPage from './pages/FecharOSPage';
import CuponsTermicosPage from './pages/CuponsTermicosPage';
import CupomTermicoFormPage from './pages/CupomTermicoFormPage';
import EstoquePage from './pages/EstoquePage';
import ServicosPage from './pages/ServicosPage';
import VendasPage from './pages/VendasPage';
import DashboardPage from './pages/DashboardPage';
import NotificationsPage from './pages/NotificationsPage';
import SettingsPage from './pages/SettingsPage';
import RelatoriosPage from './pages/RelatoriosPage';
import UsuariosPage from './pages/UsuariosPage';
import EstadosOSPage from './pages/configuracoes/EstadosOSPage';
import IntegracoesPage from './pages/integracoes/IntegracoesPage';
import WhatsAppPage from './pages/integracoes/WhatsAppPage';
import EmailPage from './pages/integracoes/EmailPage';
import PublicOrcamentoPage from './pages/PublicOrcamentoPage';
import './index.css';
// Configurar React Query
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: 1,
            refetchOnWindowFocus: false,
            staleTime: 5 * 60 * 1000, // 5 minutos
        },
        mutations: {
            retry: 1,
        },
    },
});
// Configurar router com flags futuras para suprimir warnings
const router = createBrowserRouter([
    {
        path: "/login",
        element: _jsx(LoginPage, {})
    },
    {
        path: "/register",
        element: _jsx(RegisterPage, {})
    },
    {
        path: "/public/orcamento/:id/:token",
        element: _jsx(PublicOrcamentoPage, {})
    },
    {
        path: "/",
        element: _jsx(Layout, {}),
        children: [
            {
                index: true,
                element: _jsx(Navigate, { to: "/dashboard", replace: true })
            },
            {
                path: "dashboard",
                element: _jsx(DashboardPage, {})
            },
            {
                path: "clientes",
                element: _jsx(ClientesPage, {})
            },
            {
                path: "clientes/:clienteId",
                element: _jsx(ClientesPage, {})
            },
            {
                path: "equipamentos",
                element: _jsx(EquipamentosPage, {})
            },
            {
                path: "equipamentos/:equipamentoId",
                element: _jsx(EquipamentosPage, {})
            },
            {
                path: "ordens-servico",
                element: _jsx(OrdensServicoPage, {})
            },
            {
                path: "ordens-servico/:osId",
                element: _jsx(OrdensServicoPage, {})
            },
            {
                path: "ordens-servico/:id/success",
                element: _jsx(OrdemServicoSuccessPage, {})
            },
            {
                path: "ordens-servico/:id/fechamento-success",
                element: _jsx(OrdemServicoFechamentoSuccessPage, {})
            },
            {
                path: "ordens-servico/:id/fechar",
                element: _jsx(FecharOSPage, {})
            },
            {
                path: "ordens-servico/arquivo",
                element: _jsx(OrdensServicoArquivoPage, {})
            },
            {
                path: "orcamentos",
                element: _jsx(OrcamentosPage, {})
            },
            {
                path: "orcamentos/novo",
                element: _jsx(OrcamentoFormPage, {})
            },
            {
                path: "orcamentos/:orcamentoId",
                element: _jsx(OrcamentoDetailsPage, {})
            },
            {
                path: "orcamentos/:orcamentoId/editar",
                element: _jsx(OrcamentoFormPage, {})
            },
            {
                path: "cupons-termicos",
                element: _jsx(CuponsTermicosPage, {})
            },
            {
                path: "cupons-termicos/novo",
                element: _jsx(CupomTermicoFormPage, {})
            },
            {
                path: "cupons-termicos/:id/editar",
                element: _jsx(CupomTermicoFormPage, {})
            },
            {
                path: "estoque",
                element: _jsx(EstoquePage, {})
            },
            {
                path: "servicos",
                element: _jsx(ServicosPage, {})
            },
            {
                path: "vendas",
                element: _jsx(VendasPage, {})
            },
            {
                path: "relatorios",
                element: _jsx(RelatoriosPage, {})
            },
            {
                path: "notificacoes",
                element: _jsx(NotificationsPage, {})
            },
            {
                path: "configuracoes",
                element: _jsx(SettingsPage, {})
            },
            {
                path: "configuracoes/estados-os",
                element: _jsx(EstadosOSPage, {})
            },
            {
                path: "usuarios",
                element: _jsx(UsuariosPage, {})
            },
            {
                path: "integracoes",
                element: _jsx(IntegracoesPage, {})
            },
            {
                path: "integracoes/whatsapp",
                element: _jsx(WhatsAppPage, {})
            },
            {
                path: "integracoes/email",
                element: _jsx(EmailPage, {})
            }
        ]
    },
    {
        path: "*",
        element: _jsx(Navigate, { to: "/dashboard", replace: true })
    }
], {
    future: {
        v7_relativeSplatPath: true
    }
});
const App = () => {
    return (_jsx(QueryClientProvider, { client: queryClient, children: _jsx(AuthProvider, { children: _jsx(ToastProvider, { children: _jsx(RouterProvider, { router: router }) }) }) }));
};
export default App;
